/**
 * Single source of truth for the desktop-app download links.
 *
 * Override in Vercel (or .env.local) with:
 *   REACT_APP_DOWNLOAD_MAC=https://...
 *   REACT_APP_DOWNLOAD_WIN=https://...
 *
 * Changing the URL here (or via env vars) updates every download button
 * on the landing page, dashboard, and anywhere else that imports this
 * module.
 */

export const DOWNLOADS = {
  mac: {
    url: process.env.REACT_APP_DOWNLOAD_MAC || 'https://zekai.app/vitex/files/macos/downloads/ViTex.dmg',
    filename: 'ViTex.dmg',
  },
  win: {
    url: process.env.REACT_APP_DOWNLOAD_WIN || 'https://zekai.app/vitex/files/windows/downloads/vitex-setup.exe',
    filename: 'vitex-setup.exe',
  },
};
